import { Button, toastManager } from 'admination-react'

export function toastOffline(): string {
  return toastManager.add({
    type: 'error',
    priority: 'high',
    description: (
      <>
        Keine Live-Verbindung. Die Anzeige ist nicht aktuell.{' '}
        <Button onClick={() => window.location.reload()}>Neu laden</Button>
      </>
    ),
  })
}
